import React from "react";
import {useAppSelector, useAppDispatch} from 'redux/hooks'
import {Button} from "primereact/button";
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";
import {setIVRConfigurationClearFilters, initialIVRConfigurationData, setIVRConfigurationDialogVisible, setIVRConfigurationErrorFields} from "../../../../redux/actions/actionsIVRConfiguration";
import {setEditType} from "../../../../redux/actions/actions";

const IVRConfigurationListNav = (props: any) => {
    const dispatch = useAppDispatch()
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const ivrConfigurationPermissions = checkPermissions(rolesVision, 'IVRConfig');

    const {
        create: hasIVRConfigurationCreatePermission,
    } = ivrConfigurationPermissions;

    return (
        <div className="table-buttons">
            <div>
                <Button 
                    label="IVR Конфігурації"
                    className="mr-2 mb-2"
                />
            </div>
            <div className="desktop">
                {hasIVRConfigurationCreatePermission && (
                    <Button 
                        label="Створити IVR конфігурацію"
                        icon="pi pi-plus"
                        className="mr-2 mb-2"
                        onClick={() => {
                            dispatch(initialIVRConfigurationData());
                            dispatch(setIVRConfigurationDialogVisible(true));
                            dispatch(setIVRConfigurationErrorFields(null));
                            props.setSelectedRowData(null);
                            if (hasIVRConfigurationCreatePermission) {
                                dispatch(setEditType(true));
                            } else {
                                dispatch(setEditType(false));
                            }
                        }}
                    />
                )}
                <Button 
                    type="button" 
                    icon="pi pi-filter-slash" 
                    label="Очистити фільтри" 
                    className="p-button-outlined mr-2 mb-2" 
                    onClick={() => {
                        dispatch(setIVRConfigurationClearFilters());
                        props.handleReset()
                    }}
                />
            </div>
            <div className="mobile">
                {hasIVRConfigurationCreatePermission && (
                    <Button 
                        icon="pi pi-plus"
                        className="mr-2 mb-2"
                        onClick={() => {
                            dispatch(initialIVRConfigurationData());
                            dispatch(setIVRConfigurationDialogVisible(true));
                            dispatch(setIVRConfigurationErrorFields(null));
                            props.setSelectedRowData(null);
                            if (hasIVRConfigurationCreatePermission) {
                                dispatch(setEditType(true));
                            } else {
                                dispatch(setEditType(false));
                            }
                        }}
                    />
                )}
                <Button 
                    type="button" 
                    icon="pi pi-filter-slash" 
                    className="p-button-outlined mr-2 mb-2" 
                    onClick={() => {
                        dispatch(setIVRConfigurationClearFilters());
                        props.handleReset();
                    }}
                />
            </div>
        </div>
    )
}

export default IVRConfigurationListNav

